import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import {UtilisateurWrapper} from "./Utilisateur/UtilisateurWrapper";
import {EtatChocWrapper} from "./EtatChoc/EtatChocWrapper";
import GestionRolePage from '../Role/GestionRolePage';

const ParametrageWrapper = () => {
  return (
    <Routes>
      <Route path="/utilisateurs/*" element={<UtilisateurWrapper/>}/>
      <Route path="/etat-choc/*" element={<EtatChocWrapper/>}/>
      <Route path='/role-utilisateur' element={<GestionRolePage/>}/>

      <Route path='*' element={<Navigate to='/404' replace/>}/>
    </Routes>
  )
}

export {ParametrageWrapper}